/*!
 * hoverIntent v1.9.0 // 2017.09.01 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2017 Brian Cherne
 */
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

  $(document).ready(function() {
    SwellConfig.Faq.initializeFaqs(".swell-question-button, .swell-question-list");
    SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    return SwellConfig.LocalStorage.initializeLocalStorage();
  });

  $(document).on("swell:setup", function() {
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Campaign.authenticate();
    SwellConfig.Tier.initializeDummyTier();
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-section");
    SwellConfig.Redemption.initializeCustomRedemptionProperties();
    Swell.Redemption.initializeRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
    SwellConfig.Redemption.authenticated();
    Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    SwellConfig.Customer.initializeHistory(".swell-link-history");
  });

  $(document).ready(function(){
      $( 'body' ).on('click',".swell-referral-back-link", function() {
        $(".backdrop").remove();
      });

      //for checkout....
      $( 'body' ).on('click',"#your-shopping-cart .swell-referral-back-link", function() {
        setTimeout(function(){            
          $(".swell-referral .swell-referral-content-container .swell-referral-content-main").prepend("<div class=\"heading\"><h3 class=\"heading-content\">Thank You For Your Purchase</h3><span class=\"content-model-cross-icon\"></span></div>");
          $(".swell-referral-refer .swell-referral-details").html("Give a friend 15% off their first purchase of $30 or more and get $5 in points.");
          $(".swell-referral .swell-referral-content-sidebar").remove();
          $("body").append("<div class=\"backdrop\"></div>");
          $(".swell-referral-back-link").remove();
        }, 100);
      });

      $( 'body' ).on('click',".newsletter", function() {
        swellAPI.showPopupByType("EmailCapturePopup");
      });

      $("#swell-popup").contents().on("click", ".swell-button-item", function() {
           alert("test");//do something
       });

      $('body').one("DOMSubtreeModified",".swell-campaign-list",function(){
        setTimeout(function(){
            allowed_campaigns = ["348910", "348908", "361251","488087", "475486", "487072"];
            $(".swell-campaign-list > li").each(function() {
              if(!(allowed_campaigns.indexOf(this.dataset.campaignId) > -1)) {
                this.remove();
              }
            });
        }, 300)
      });    

      // checkout model code start.....
      $('body').on('click', ".content-model-cross-icon", function(){
        $(".backdrop").remove();
        $(".swell-referral").remove();
      });

      // for checkout .....
      $('body').on('click', "#your-shopping-cart .swell-referral-medium-content", function(){
        $(".heading").remove();
      });

      $( 'body' ).one('DOMSubtreeModified',".swell-referral", function() {
        setTimeout(function(){
          // remove referral sidebar if it is in thank_you.....
          $(".swell-referral-form-list-submit").val("Next");
          $(".swell-referral-refer #swell-referral-refer-submit").val("Send");
          $(".swell-referral-refer .swell-referral-details").html("Give your friends 20% off on their first order of $40+ and get 20% for each successful referral.");
          $(".swell-referral-refer .swell-referral-form-field-details").html("Separated by commas");
          $(".swell-referral-refer .swell-referral-media-wrapper").prepend("<div class=\"border\"></div>");
        }, 100);
        
      });

      //for checkout .......
      $( 'body' ).one('DOMSubtreeModified',"#your-shopping-cart .swell-referral", function() {
        setTimeout(function(){         
          $(".swell-referral .swell-referral-content-container .swell-referral-content-main").prepend("<div class=\"heading\"><h3 class=\"heading-content\">Thank You For Your Purchase</h3><span class=\"content-model-cross-icon\"></span></div>");
          $(".swell-referral-refer .swell-referral-details").html("Give a friend 15% off their first purchase of $30 or more and get $5 in points.");
          $(".swell-referral .swell-referral-content-sidebar").remove();
          $("body").append("<div class=\"backdrop\"></div>");
          $(".swell-referral-back-link").remove();
          $("#your-shopping-cart.swell-checkout").show();
        }, 100);
        
      });

      //swell-referral-refer div loading here.....
      $('body').on('click', '.swell-referral-form-list-submit', function() {
        fbq('track', 'Lead');
        setTimeout(function(){
          // $(".logout-refferal .swell-referral").removeClass("swell-referral-logout-sidebar-img");
          $(".swell-referral-refer #swell-referral-refer-submit").val("Send");
          $(".swell-referral-refer .swell-referral-details").html("Give your friends 20% off on their first order of $40+ and get 20% for each successful referral.");
          $(".swell-referral-refer .swell-referral-form-field-details").html("Separated by commas");
          $(".swell-referral-refer .swell-referral-media-wrapper").prepend("<div class=\"border\"></div>");
        }, 2000);
      });
      
      $('body').on('click', '.swell-share-referral-copy', function(){
        $(".swell-referral-refer").hide();
        if ($(".swell-referral-copy-content").length > 0){
          $(".swell-referral-copy-content").detach().insertAfter(".swell-referral-refer");
          $("body").append("<div class=\"backdrop\"></div>");
        }

        setTimeout(function(){
          $(".swell-referral-copy-content").detach().insertAfter(".swell-referral-refer");
          $("body").append("<div class=\"backdrop\"></div>");
        }, 100);
      });
    });

    reloadReferre = function() {
      setTimeout(function(){
        $(".swell-referral-refer #swell-referral-refer-submit").val("Send");
        $(".swell-referral-refer .swell-referral-details").html("Give your friends 20% off on their first order of $40+ and get 20% for each successful referral.");
        $(".swell-referral-refer .swell-referral-form-field-details").html("Separated by commas");
        $(".swell-referral-refer .swell-referral-media-wrapper").prepend("<div class=\"border\"></div>");
      }, 100);
    };


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class=\"compaign-box swell-campaign-link\"\n data-display-mode=\"modal\"\n data-campaign-id=\"<%= campaign.id %>\">\n <div class=\"compaign-box-image\">\n <img src=\"<%= campaign.background_image_url %>\" class=\"compaign-image\">\n <div class=\"caption\">\n <i class=\"<%= campaign.icon %>\"><span class='path1'></span><span class='path2'></span></i>\n <h6><%= campaign.title %></h6>\n <a href=\"javascript:void(0)\" class=\"btn btn-default blue-button\"><%= campaign.reward_text %></a>\n </div>\n </div>\n </li>",
        campaignHover: ""
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign-content");
        $(".swell-campaign").addClass("swell-campaign-login");
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Customer = {
    initializeHistory: function(containerSelector) {
      return $(containerSelector).click(function() {
        return swellAPI.showPopupByType("HistoryPopup");
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Faq = {
    initializeFaqs: function(containerSelector) {
      var collapsed_text, expanded_text;
      expanded_text = "Show Less <i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i>";
      collapsed_text = "Show All FAQs <i class=\"fa fa-chevron-down\" aria-hidden=\"true\"></i>";
      return $(containerSelector).click(function(e) {
        var $swell_question_list;
        if ($(e.target).is(containerSelector)) {
          $swell_question_list = $(".swell-question-list");
          $swell_question_list.toggleClass("swell-question-list-expanded");
          return $(".swell-question-button").html($swell_question_list.hasClass("swell-question-list-expanded") ? expanded_text : collapsed_text);
        }
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/loyalty-program");
        return window.location = href;
      });
    },
    initializeAnchor: function() {
      return setTimeout(function() {
        return $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top,
          'slow': 'slow'
        });
      }, 1000);
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOption: "<li class=\"redeem-box <%= redemption.icon %> swell-redemption-option\">\n <div class=\"redeem-box-holder\">\n <div class=\"redeem-content\">\n <h2><%= redemption.name %></h2>\n <h5><%= redemption.cost_text %></h5>\n </div>\n </div>\n <div class=\"swell-redemption-link\" data-redemption-option-id=\"<%= redemption.id %>\">\n <div class=\"button-holder\">\n <a href=\"javascript:void(0)\" class=\"btn btn-default blue-button\">Redeem Now</a>\n </div>\n </div>\n </li>"
      }
    },
    initializeCustomRedemptionProperties: function() {
      redemptions = spapi.activeRedemptionOptions;
      redemptions.forEach(function(redemption){
        if(redemption.id === 235183){
          redemption.name = "$10";
          redemption.cost_text = "100 points";
        }else if(redemption.id === 235184){
          redemption.name = "$20";
          redemption.cost_text = "200 points";
        }else if(redemption.id === 235185){
          redemption.name = "$30";
          redemption.cost_text = "300 points";
        }
      });
    },
    authenticated: function(){
      if(spapi.authenticated){
        $(".swell-redemption-option-list .redeem-box .swell-redemption-link").addClass("athover");
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralRegisterHeading: "<div class=\"refer-content\"\n>Refer a Friend</div>Give 20%, Get 20%",
        referralRegisterDetails: "Give your friends 20% off on their first order of $40+ and get 20% for each successful referral.",
        referralRegisterFormDetails: "First, please submit your email below.",
        referralReferHeading: "<div class=\"refer-content\"\n>Refer a Friend</div>Give 20%, Get 20%",
        referralReferDetails: "Give your friends 20% off on their first order of $40+ and get 20% for each successful referral.",
        referralThanksHeading: "Thanks for Referring.",
        referralReferMediaDetails: "You can also share your link with the buttons below.",
        referralReferFormDetails: "Enter your friend's emails in the space below",
        referralReferFormEmailsDetails: "",
        referralRegisterFormEmail: "Your email",
        referralReferFormEmails: "Your Friend's Email",
        referralRegisterFormEmail: "Your email address",

        referralShareMessenger: "Message",
        referralShareSMS: "SMS",
        referralSMSIcon: "icon-SMS",
        referralShareEmail: "Email",
        referralEmailIcon: "fa fa-envelope-o",
        referralMessengerIcon: "fa fa-comment",
      },
      templates: {
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> </ul> </div> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareCopy %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-email"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralEmailIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareEmail %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareMessenger %> </div> </li> </ul> </div> </div>',
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      columnLength = $(".swell-tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");
      encouragement = "";
      dollar_difference = "";
      for (col = k = 1, ref = columnLength - 1; 1 <= ref ? k <= ref : k >= ref; col = 1 <= ref ? ++k : --k) {
        data_id = $(".swell-tier-table tbody tr:first td:eq(" + (col - 1) + ")").first().data("tierId");
        if (data_id === customer_tier_id) {
          for (index = l = 1, ref1 = col; 1 <= ref1 ? l <= ref1 : l >= ref1; index = 1 <= ref1 ? ++l : --l) {
            $tierValueRow.find("th:eq(" + index + ")").addClass("completed");
          }
        }
        if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
          encouragement = "You are in the top tier";
        } else {
          encouragement = "Level Up: " + next_tier.name + "<span>Spend $" + ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100) + " more</span>";
        }
      }
      return $tierStatusRow.append("<th colspan=\"3\" scope=\"col\">" + encouragement + "</th>");
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      if(tiers.length === 1){
        for (k = 0, len = tiers.length; k < len; k++) {
          tier = tiers[k];
          tier.rank += 1;
        }
          tiers.unshift({
          id: -2,
          rank: 0,
          name: "Level 2",
          points: "$1&ndash;$199",
          one_point_multiplier: "1.5x point multiplier",
          exclusive_products: "Early access to sales",
          exclusive_coupon: "",
          background_image_url: "//www.oarsandalps.com/cdn/shop/t/262/assets/level1.jpg?v=17748937932950797591761748559",
          swellrequiredAmountSpent: "$0",
          amount_spent_cents: 100,
          swellrequiredPointsEarned: 0,
          swellrequiredPurchasesMade: 0,
          swellrequiredReferralsCompleted: 0
        });
      }
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Level 1",
        points: "Create An Account",
        one_point_multiplier: "1x point multiplier",
        exclusive_products: "",
        exclusive_coupon: "",
        background_image_url: "//www.oarsandalps.com/cdn/shop/t/262/assets/level1.jpg?v=17748937932950797591761748559",
        swellrequiredAmountSpent: "$0",
        amount_spent_cents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].subscribers = '';

      spapi.activeVipTiers[1].points = "$1&ndash;$199 Total Spend";
      spapi.activeVipTiers[1].background_image_url = "//www.oarsandalps.com/cdn/shop/t/262/assets/level1.jpg?v=17748937932950797591761748559";
      spapi.activeVipTiers[1].one_point_multiplier = "1.5x point multiplier";
      spapi.activeVipTiers[1].exclusive_products = "Early access to sales";
      spapi.activeVipTiers[1].exclusive_coupon = "";
      spapi.activeVipTiers[1].subscribers = '';
      
      spapi.activeVipTiers[2].name = "Level 3";
      spapi.activeVipTiers[2].points = "$200+ Total Spend";
      spapi.activeVipTiers[2].background_image_url = "//www.oarsandalps.com/cdn/shop/t/262/assets/level3.jpg?v=98508940471749865301761748556";
      spapi.activeVipTiers[2].one_point_multiplier = "2x point multiplier";
      spapi.activeVipTiers[2].exclusive_products = "Early access to new products";
      spapi.activeVipTiers[2].exclusive_coupon = "Coupon upon entering tier";
      spapi.activeVipTiers[2].amount_spent_cents = 20000;
      spapi.activeVipTiers[2].subscribers = '<p class="subscribers_level3"><small>Subscribers automatically earn 2X points</small></p>';
    },
    initializeTiers: function(containerSelector) {
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      if(spapi.authenticated){
        next_tier_spent = 0;
        current_tier_msg = "<p>Current Level</p>\n";
        next_tier_msg = "";
        tier_state = swellAPI.getCustomerDetails().vipTierStats;
        tier_state.amountSpentCents;
        tier_state.pointsEarned = 109;
        if (tier_state.amountSpentCents >= 0 && tier_state.amountSpentCents <= 99) {
          next_tier_spent = (tiers[1].amount_spent_cents - tier_state.amountSpentCents)/100;
          next_tier_msg = "<div class=\"points-block\">\n<p>Spend $"+ next_tier_spent +" more for next level</p>\n</div>";
          $(".login-earn .earn-holder").append(next_tier_msg);
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <img src="'+tiers[0].background_image_url+'" class="earn-image"> <div class="level-block"> <p>Current Level</p> <img src="//www.oarsandalps.com/cdn/shop/t/262/assets/random-line.png?v=147954879145964525621761748557" alt="Random-Line Image" class="random-line-image"> </div> <div class="caption"> <h3>'+tiers[0].name+'</h3> <p>'+tiers[0].points+'</p> <h4>'+tiers[0].one_point_multiplier+'</h4> <h4>'+tiers[0].exclusive_products+'</h4> <h4>'+tiers[0].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[1].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[1].name+'</h3> <p>'+tiers[1].points+'</p> <h4>'+tiers[1].one_point_multiplier+'</h4> <h4>'+tiers[1].exclusive_products+'</h4> <h4>'+tiers[1].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[2].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[2].name+'</h3> <p>'+tiers[2].points+'</p> <h4>'+tiers[2].one_point_multiplier+'</h4> <h4>'+tiers[2].exclusive_products+'</h4> <h4>'+tiers[2].exclusive_coupon+'</h4> '+tiers[2].subscribers+' </div> </div> </li>');
        }else if (tier_state.amountSpentCents >= 100 && tier_state.amountSpentCents <= 19900) {
          next_tier_spent = (tiers[2].amount_spent_cents - tier_state.amountSpentCents)/100;
          next_tier_msg = "<div class=\"swell_tier_2 points-block\">\n<p>Spend $"+ next_tier_spent +" more for next level</p>\n</div>";
          $(".login-earn .earn-holder").append(next_tier_msg);
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[0].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[0].name+'</h3> <p>'+tiers[0].points+'</p> <h4>'+tiers[0].one_point_multiplier+'</h4> <h4>'+tiers[0].exclusive_products+'</h4> <h4>'+tiers[0].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <img src="'+tiers[1].background_image_url+'" class="earn-image"> <div class="level-block"> <p>Current Level</p> <img src="//www.oarsandalps.com/cdn/shop/t/262/assets/random-line.png?v=147954879145964525621761748557" alt="Random-Line Image" class="random-line-image"> </div> <div class="caption"> <h3>'+tiers[1].name+'</h3> <p>'+tiers[1].points+'</p> <h4>'+tiers[1].one_point_multiplier+'</h4> <h4>'+tiers[1].exclusive_products+'</h4> <h4>'+tiers[1].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[2].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[2].name+'</h3> <p>'+tiers[2].points+'</p> <h4>'+tiers[2].one_point_multiplier+'</h4> <h4>'+tiers[2].exclusive_products+'</h4> <h4>'+tiers[2].exclusive_coupon+'</h4> '+tiers[2].subscribers+' </div> </div> </li>');
        }else if (tier_state.amountSpentCents >= 20000) {
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[0].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[0].name+'</h3> <p>'+tiers[0].points+'</p> <h4>'+tiers[0].one_point_multiplier+'</h4> <h4>'+tiers[0].exclusive_products+'</h4> <h4>'+tiers[0].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <div class="no-active-block"></div> <img src="'+tiers[1].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[1].name+'</h3> <p>'+tiers[1].points+'</p> <h4>'+tiers[1].one_point_multiplier+'</h4> <h4>'+tiers[1].exclusive_products+'</h4> <h4>'+tiers[1].exclusive_coupon+'</h4> </div> </div> </li>');
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"> <img src="'+tiers[2].background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tiers[2].name+'</h3> <p>'+tiers[2].points+'</p> <h4>'+tiers[2].one_point_multiplier+'</h4> <h4>'+tiers[2].exclusive_products+'</h4> <h4>'+tiers[2].exclusive_coupon+'</h4> '+tiers[2].subscribers+' </div> </div> </li>');
        }
      }else{
        tiers.forEach(function(tier){
          $(containerSelector).append('<li class="earn-box box-image-1"> <div class="earn-box-image"><img src="'+tier.background_image_url+'" class="earn-image"> <div class="caption"> <h3>'+tier.name+'</h3> <p>'+tier.points+'</p> <h4>'+tier.one_point_multiplier+'</h4> <h4>'+tier.exclusive_products+'</h4> <h4>'+tier.exclusive_coupon+'</h4> '+tier.subscribers+' </div> </div> </li>');
        });
      }
    }
  };

}).call(this);

(function() {
  var classNames, selectors,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  classNames = {
    container: "swell-question-content",
    heading: "swell-question-heading",
    section: "swell-question-details",
    open: "swell-question-open"
  };

  selectors = {
    container: "." + classNames.container,
    heading: "." + classNames.heading,
    section: "." + classNames.section,
    open: "." + classNames.open
  };

  $(document).ready(function() {
    var hash, heading, openCollapsiblesForAnchor, toHide;
    openCollapsiblesForAnchor = function(hash, redirect) {
      var anchors, el, name;
      name = hash.substr(1);
      anchors = $(selectors.container).find(hash + ", a[name=\"" + name + "\"]");
      if (anchors.length > 0) {
        el = $(anchors[0]);
        el.closest(selectors.container).find(selectors.heading).click();
        return el.closest(selectors.section).promise().done(function() {
          return window.location = redirect;
        });
      } else if ($(hash).is(selectors.container)) {
        return $(hash).find(selectors.heading).click();
      }
    };
    $(selectors.container).css("overflow", "hidden");
    toHide = $(selectors.container).not(selectors.open).find(selectors.section);
    heading = $(selectors.heading);
    toHide.hide();
    heading.css("cursor", "pointer");
    heading.click(function() {
      var parent, t;
      t = $(this);
      parent = t.parent();
      if (parent.hasClass(classNames.open)) {
        parent.removeClass(classNames.open);
        t.attr("aria-expanded", "false");
      } else {
        parent.addClass(classNames.open);
        t.attr("aria-expanded", "true");
      }
      t.next().slideToggle("fast");
      return false;
    });
    $(document).keydown(function(e) {
      if ((32 === e.keyCode || 13 === e.keyCode) && $(e.target).hasClass(classNames.heading)) {
        e.preventDefault();
        e.target.click();
        return false;
      }
    });
    if (window.location.hash) {
      hash = window.location.hash;
      openCollapsiblesForAnchor(hash, window.location);
    }
    if (indexOf.call(window, "onhashchange") >= 0) {
      return $(window).bind("hashchange", function(e) {
        hash = window.location.hash;
        return openCollapsiblesForAnchor(hash, window.location);
      });
    }
  });

}).call(this);
